export function canReadOperationLogs(
  permissions: readonly string[] | undefined,
): boolean {
  return Boolean(permissions?.includes('audit.read'));
}
